module.exports = "/_next/static/images/c3483137d10f2d01358b3850e5c4bbbb-computer-desk-man@lg-1x.jpg.webp";